import { useContext, useEffect, useState } from "react";
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import { AuthContext } from '../../../../auth/context/auth-context';
import { IPanelEmpresaEditar } from './actualizarEmpresa';
import { IEmpresaCommandEdit } from "../../../../interfaces/IEmpresa";
import EmpresaService from "../../../../services/empresaService";

const UseActualizarEmpresa = (props: IPanelEmpresaEditar) => {
    const { access } = useContext(AuthContext);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [buttonSalir, setButtonSalir] = useState<boolean>(false)
    const initial: IEmpresaCommandEdit = {
        empresaId: "",
        nombre: null,
        nombreCorto: null,
        esTitular: null,
        esTransportista: null,
        esVuelo: null,
        trasladoTitular: null,
        trasladoContratista: null,
    }
    const [command, setCommand] = useState<IEmpresaCommandEdit>(initial)
    const [disableForm, setDisableForm] = useState<boolean>(true);

    const putEditarEmpresa = () => {
        setLoading(true)
        EmpresaService.actualizaEmpresa(command)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)

            }).catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setButtonSalir(true)
                    setMensaje(mensajeError);

                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setCommand(initial)
        setStatus(0)
        props.onDismiss()
    }


    let required: (keyof IEmpresaCommandEdit)[] = [
        "empresaId",
    ];

    /* if (!access?.role?.includes("Admin")) {
        required = [
            "codigo",
            "diasLaborables",
            "diasDescanso",
            "guardiaProgramacionId"
        ]
    } */

    useEffect(() => {
        if (props.isOpen) {
            setCommand({
                ...command,
                empresaId: props.empresaData.empresaId,
                nombre: props.empresaData.nombre,
                nombreCorto: props.empresaData.nombreCorto,
                esTitular: props.empresaData.esTitular == "Si" ? true : false,
                esTransportista: props.empresaData.esTransportista == "Si" ? true : false,
                esVuelo: props.empresaData.esVuelo == "Si" ? true : false,
                trasladoTitular: props.empresaData.trasladoTitular == "Si" ? true : false,
                trasladoContratista: props.empresaData.trasladoContratista == "Si" ? true : false
            })
        }
    }, [props.isOpen])

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, putEditarEmpresa, loading, reset, mensaje, status, disableForm, buttonSalir }
}

export { UseActualizarEmpresa }